<template>
  <div class="overflow-y-scroll h w-100">
    <div class="h4 db w-100 cover center bg-image"></div>
    <div class="position-100 relative">
      <div class="flex items-center ma3 h4">
        <div v-tooltip="{
                content: msg,
                placement: 'bottom-center',
                classes: 'my_tooltip',
                offset: 5,
                delay: {
                  show: 10,
                  hide: 10,
                },
              }" v-show="user" class="db br-100 w4 min-w4 h4 cover relative flex items-end justify-center"
             :style=" { 'background-image': 'url(' + picture + ')' }">
          <div v-show="files.length && files[0].progress < 100" class="flex justify-center items-center h4 w4">
            <clip-loader :loading="true" :color="color" :size="size"></clip-loader>
          </div>
          <div v-show="!files.length" class="flex justify-center items-end">
            <file-upload
              class="ph2 pointer"
              :post-action="url"
              :headers="postFileHeaders"
              extensions="jpg,jpeg,png,webp"
              v-model="files"
              ref="imageUpload"
              input-id="file1"
              @input-file="imageInputFile"
              @input-filter="imageInputFilter">
              <div class="edit-button bg-primary ma2 br-100 flex items-center justify-center pointer">
                <font-awesome-icon class="white" icon="camera"/>
              </div>
            </file-upload>
          </div>
        </div>
        <h1 v-if="user" class="ttu ma3-ns ma2 secondary fw5 f2-ns f5 name textColor">{{user.first_name}} {{user.last_name}}</h1>
      </div>
      <div class="flex bb bw1 mh6-l mh5-m mh3 mt33">
        <router-link v-show="!bitelFreeMusic" :to="{ name: 'profile-info' }" replace
                     class="w4 ttu pa2 pointer flex justify-center items-center textColor no-underline link-primary">
          {{$t("users.userMenu.myProfile")}}
        </router-link>
        <router-link :to="{ name: 'my-tracks' }" replace v-if="isProducer"
                     class="w4 ttu pa2 pointer flex justify-center items-center textColor no-underline link-primary">
          {{$t("users.userMenu.myTracks")}}
        </router-link>
        <router-link :to="{ name: 'my-playlists' }" replace
                     class="w4 ttu pa2 pointer flex justify-center items-center textColor no-underline link-primary">
          {{$t("users.userMenu.myPlaylists")}}
        </router-link>
        <router-link :to="{ name: 'my-favorites' }" replace
                     class="w4 ttu pa2 pointer flex justify-center items-center textColor no-underline link-primary">
          {{$t("users.userMenu.myFavorites")}}
        </router-link>
        <router-link v-show="!bitelFreeMusic" :to="{ name: 'my-shopping' }" replace
                     class="w4 ttu pa2 pointer flex justify-center items-center textColor no-underline link-primary">
          {{$t("users.userMenu.myShopping")}}
        </router-link>
      </div>
      <div class="mh6-l mh5-m mh3">
        <router-view></router-view>
      </div>
    </div>
  </div>
</template>

<script>
  import consts from '@/consts'
  import FontAwesomeIcon from '@fortawesome/vue-fontawesome'
  import FileUpload from 'vue-upload-component'
  import auth from '@/auth'
  import {mapGetters, mapActions} from 'vuex'
  import ClipLoader from 'vue-spinner/src/ClipLoader.vue'

  export default {
    name: 'user-profile',
    data () {
      return {
        routeName: 'Info',
        files: [],
        color: '#808080',
        size: '30px',
        msg: 'Img size 170x170',
        bitelFreeMusic: false
      }
    },
    components: {
      FontAwesomeIcon,
      FileUpload,
      ClipLoader
    },
    created () {
      this.resetError()
    },
    mounted () {
      let msisdn = localStorage.getItem('msisdn')
      if (msisdn && msisdn === 'freeMusic') {
        this.bitelFreeMusic = true
      } else {
        this.bitelFreeMusic = false
      }
    },
    computed: {
      ...mapGetters('user', [
        'isLoggedIn',
        'isSubscribed',
        'isProducer',
        'user'
      ]),
      picture () {
        if (this.user) {
          if (this.user.picture) {
            return consts.MEDIA_BASE_URL + this.user.picture
          }
        } else {
          return '/static/assets/Img_Avatar_generico_Beathey.jpg'
        }
      },
      url () {
        if (this.user) {
          if (this.user.picture) {
            return consts.API_BASE_URL + '/users/uploadUserPicture/picture'
          } else {
            return consts.API_BASE_URL + '/artists/uploadArtistPicture/picture'
          }
        }
      },
      postFileHeaders: function () {
        return auth.getHeader()
      }
    },
    methods: {
      ...mapActions('user', [
        'updateProfileImage'
      ]),
      ...mapActions('artist', [
        'resetError'
      ]),
      imageInputFile: function (newFile, oldFile) {
        // auto start
        if (Boolean(newFile) !== Boolean(oldFile) || oldFile.error !== newFile.error) {
          if (!this.$refs.imageUpload.active) {
            this.$refs.imageUpload.active = true
          }
        }
        if (newFile && oldFile) {
          if (newFile.success !== oldFile.success) {
            if (newFile.response) {
              if (newFile.response.status === 'error') {
                this.$toasted.show(this.$t('error.imageUpload'), {type: 'error'})
              } else {
                this.updateProfileImage(newFile.response.data)
              }
              this.files = []
            }
          }
        }
      },
      imageInputFilter: function (newFile, oldFile, prevent) {
        if (newFile && !oldFile) {
          // Filter non-image file
          if (!/\.(jpg|jpeg|png|webp)$/i.test(newFile.name)) {
            this.$toasted.show(this.$t('tracks.newTrack.imageType'), {type: 'error'})
            return prevent()
          }
        }
      }
    }
  }
</script>

<style scoped lang="scss">
  @import '~@/variables.scss';

  .router-link-active, .link-primary:hover {
    background-color: $primary-color;
    color: $text-color;
    transition: .3s;
  }

  .h {
    height: $main-height;
  }

  h1 {
    background: rgba(0, 0, 0, 0.3);
  }

  .bg-image {
    background-image: url("/static/assets/profile-background.jpg")
  }

  .bb{
    border-bottom-style: solid;
    border-bottom-width: 1px;
    color: #aaa;
  }

  .position-100 {
    top: -100px;
  }

  .edit-button {
    min-width: 40px;
    min-height: 40px;
    widows: 40px;
    height: 40px;
  }

  .min-w4 {
    min-width: 8rem;
  }

  .name {
    white-space: nowrap;
    max-width: 100%;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .mt33 {
    margin-top: 33px;
  }

  .v-tooltip__content {
    color: #aaa !important;
  }

  .my_tooltip {
    color:#aaa
  }
</style>



// WEBPACK FOOTER //
// src/components/user/UserProfile.vue